'use client';

import { errorMsgs } from './constants.js';

var Base = /** @class */ (function () {
    function Base(translate) {
        this.rules = [];
        this.translate = translate;
    }
    Base.prototype.require = function (msg) {
        this.rules.push({
            type: 'required',
            msg: msg || errorMsgs(this.translate).required
        });
        return this;
    };
    Base.prototype.custom = function (validator, msg) {
        this.rules.push({
            type: 'custom',
            msg: msg,
            validator: validator
        });
        return this;
    };
    Base.prototype.generate = function () {
        return this.rules;
    };
    return Base;
}());

export { Base as default };
//# sourceMappingURL=base.js.map
